import React from 'react';
import {
  Button,
  //Col,
  Tooltip,
  //Row,
  Space,
} from 'antd';

import {
  DataGrid,
  DeleteButton,
  HoverBgButton,
  Loading,
  ScreenMask,
  message,
} from 'components/common';
import {
  ButtonIcon,
  //Label,
  //MainList,
} from 'components/common/styles';
import {
  COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
  LOADING_ICON_SIZE1,
} from 'constants/config';
import {
  addPickListProfile2,
  deletePickListProfile,
  fetchPickListProfileList,
} from 'services/sales';
import { EDIT_FILTER_MODE_UPDATE } from '.';
import SaveFilterProfileDialog from './SaveFilterProfileDialog';

type Props = {
  editProfile: Function;
  newProfileId: number;
  selectProfile: Function;
  visible: boolean;
};

const FilterProfileList = (props: Props) => {
  const { useState } = React;
  const [editFilterProfileDialogVisible, setEditFilterProfileDialogVisible] = useState(false);
  const [filterProfile, setFilterProfile] = useState<StringKAnyVPair>({});
  const [inited, setInited] = useState(false);
  const [lastProfileId, setLastProfileId] = useState(0);
  const [lockScreen, setLockScreen] = useState(false);
  const [profileList, setProfileList] = useState<StringKAnyVPair[]>([]);

  const columns = [
    {
      header: 'Name',
      name: 'name',
    },
    {
      header: 'Saved by',
      name: 'createBy',
    },
    {
      header: 'Action',
      headerAlign: 'start',
      maxWidth: 330,
      showColumnMenuTool: false,
      sortable: false,
      textAlign: 'center',
      render(row: any) {
        const { data: item } = row;

        return (<>
          <Space>
            <Tooltip
              title={`Select Filter Profile '${item.name}'`}
              trigger="hover"
            >
              <HoverBgButton
                hovertype="info"
                onClick={() => handleSelectProfile(item)}
              >
                <ButtonIcon className="bi-hand-index-thumb" />
                Select
              </HoverBgButton>
            </Tooltip>
            <Button onClick={() => openRenameFilterProfileDialog(item)}>
              <ButtonIcon className="bi-pencil-fill" />
              Edit
            </Button>
            <Tooltip
              placement="topRight"
              title={`Delete Filter Profile '${item.name}'`}
              trigger="hover"
            >
              <DeleteButton
                confirmContent={`Are you sure you want to delete Filter Profile '${item.productTitle}'?`}
                confirmTitle="Delete Filter Profile"
                onClick={() => deleteProfile(item)}
              />
            </Tooltip>
          </Space>
        </>);
      },
    },
  ];

  const deleteProfile = async (profile: StringKAnyVPair) => {
    console.log('pid', profile);
    setLockScreen(true);
    try {
      const res = await deletePickListProfile(profile.pickProfileNum);

      console.log('resss', res);
      if (res) {
        getPickListProfileList();
      } else {
        setLockScreen(false);
        message.error(`Delete profile '${profile.productTitle}' failed`);
      }
    } catch (e) {
      setLockScreen(false);
      message.error(`Delete profile '${profile.productTitle}' error`);
    }
  };

  const getPickListProfileList = async () => {
    const list = await fetchPickListProfileList();

    console.log(list);
    setLockScreen(false);

    if (list && Array.isArray(list)) {
      setProfileList(list);
    }
  };

  /*
  const handleEditProfile = (profile: StringKAnyVPair) => {
    props.editProfile(profile);
  };*/

  const handleSelectProfile = (profile: StringKAnyVPair) => {
    props.selectProfile(profile);
    setLastProfileId(profile.pickProfileNum);
  };

  const openRenameFilterProfileDialog = (filter: StringKAnyVPair) => {
    setFilterProfile(filter);
    setEditFilterProfileDialogVisible(true);
  };

  const renameFilterProfile = async (name: string) => {
    //console.log('n', name, filterProfile);
    const filter = { ...filterProfile, name };
    const res = await saveFilterProfile(filter);

    res && getPickListProfileList();
  };

  const saveFilterProfile = async (profile: StringKAnyVPair) => {
    let ret = false;

    setLockScreen(true);
    try {
      const save = await addPickListProfile2(profile);

      if (save && 'object' === typeof save) {
        if (save.pickProfileNum) {
          ret = true;
          message.success('Saved filter profile successfully');
        } else {
          message.error('Saved filter profile failed');
        }
      } else {
        message.error('Saved filter profile failed');
      }
    } catch(e) {
      message.error({
        content: `Saved filter profile error: ${e}`,
        duration: COMMON_ERR_MSG_DEFAULT_DISPLAY_DURATION,
      });
    } finally {
      setLockScreen(false);
    }

    return ret;
  };

  React.useEffect(() => {
    const { newProfileId } = props;
    let isFetchingList = false;

    if (!inited) {
      if (props.visible) {
        setLockScreen(true);
        getPickListProfileList();
        setInited(true);
        isFetchingList = true;
      }
    }

    if (newProfileId > 0 && newProfileId !== lastProfileId) {
      setLastProfileId(newProfileId);

      if (!isFetchingList) {
        setLockScreen(true);
        getPickListProfileList();
      }
    }
  }, [inited, lastProfileId, props]);

  return (
    <>
      {/*<Label className="label-bold">Profile Name</Label>*/}
      <DataGrid
        columns={columns}
        dataSource={profileList}
        pagination={false}
        rowKey="pickProfileNum"
      />
      {/*<MainList
        bordered
        dataSource={profileList}
        renderItem={(item: any) => (
          <MainList.Item>
            <Row
              align="middle"
              justify="space-between"
              style={{ width: '100%' }}
            >
              <Col>{item.productTitle}</Col>
              <Col>
                <Space>
                  <Tooltip
                    title={`Select Filter Profile '${item.productTitle}'`}
                    trigger="hover"
                  >
                    <HoverBgButton
                      hovertype="info"
                      onClick={() => handleSelectProfile(item)}
                    >
                      <ButtonIcon className="bi-hand-index-thumb" />
                      Select
                    </HoverBgButton>
                  </Tooltip>
                  <Tooltip
                    placement="topRight"
                    title={`Delete Filter Profile '${item.productTitle}'`}
                    trigger="hover"
                  >
                    <DeleteButton
                      confirmContent={`Are you sure you want to delete Filter Profile '${item.productTitle}'?`}
                      confirmTitle="Delete Filter Profile"
                      onClick={() => deleteProfile(item)}
                    />
                  </Tooltip>
                </Space>
              </Col>
            </Row>
          </MainList.Item>
        )}
      />*/}
      {editFilterProfileDialogVisible && (
        <SaveFilterProfileDialog
          close={() => setEditFilterProfileDialogVisible(false)}
          editMode={EDIT_FILTER_MODE_UPDATE}
          profileName={filterProfile.name}
          save={renameFilterProfile}
          visible={editFilterProfileDialogVisible}
        />
      )}
      {lockScreen ? (
        <ScreenMask>
          <Loading size={LOADING_ICON_SIZE1} />
        </ScreenMask>
      ) : (
        ''
      )}
    </>
  );
};

export default FilterProfileList;
